export default "__VITE_ASSET__DHj_wm24__"